import React, { useEffect } from "react";
import { ExerciseCard } from "../../components/ExerciseCard";
import { mockComprendreExercises } from "../../modules/exercises.mock";
import { MixmindUniverse, useUniverse } from "../../context/UniverseContext";

// Academy – Comprendre : exemples de contenus conceptuels (placeholder).
export default function AcademyComprendre() {
  const { setUniverse } = useUniverse();
  useEffect(() => {
    setUniverse(MixmindUniverse.Academy);
  }, [setUniverse]);

  return (
    <div className="max-w-5xl mx-auto space-y-6">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Academy · Comprendre</h1>
        <p className="text-sm md:text-base text-slate-700 dark:text-slate-300">
          Fiches concept et exemples de contenus pour clarifier les notions clés (démonstration).
        </p>
      </header>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Exemples de contenus</h2>
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {mockComprendreExercises.map((ex) => (
            <ExerciseCard key={ex.id} exercise={ex} />
          ))}
        </div>
        {/* TODO MixMind: ajouter de vraies fiches concept avec filtres par âge/rôle. */}
      </section>
    </div>
  );
}
